import React from 'react';

const ProductSpinner = ({ minHeight = '300px', textColor = '#333' }) => {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight }}>
      <div className="product-spinner">
        <div className="spinner-circle"></div>
        <p className="spinner-text" style={{ color: textColor }}>Loading Products...</p>
      </div>

      <style jsx>{`
        .product-spinner {
          position: relative;
          width: 80px;
          height: 80px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .spinner-circle {
          position: absolute;
          width: 50px;
          height: 50px;
          border: 4px solid transparent;
          border-top-color: #ff6701;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .spinner-text {
          position: absolute;
          bottom: -60px;
          font-size: 14px;
          font-weight: 500;
          text-align: center;
          animation: pulse 1.5s ease-in-out infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default ProductSpinner;